interface IFeatureFlags {
  CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: boolean
  ALLOW_OLD_PREVIEW_PAGE: boolean
}

const configuration: Record<string, IFeatureFlags> = {
  development: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
  },
  staging: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
  },
  interop: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
  },
  beta: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
  },
  production: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
  },
}

export const featureFlags = configuration[(process.env.mode || process.env.NODE_ENV) as string]
